export default {
      id: "ok-usage",
      viewBox: "0 0 18 14",
      url: __webpack_public_path__ + "img/icons.svg#ok",
      toString: function () {
        return this.url;
      }
    }